// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import type { HttpClient } from "./interfaces";
import { createFetchHttpClient } from "./fetchHttpClient";

/**
 * Create the correct HttpClient for the current environment.
 */
export function createDefaultHttpClient(): HttpClient {
  return createFetchHttpClient();
}